.nav {
  display: flex;
  align-items: center;
  margin: auto 20px;
  height: 30px;
}

.no-margin {
  margin: 0;
}

.nav-item-title {
  margin-right: 25px;
  display: flex;
  align-items: center;
}

.nav-item:hover .nav-item-children {
  display: block;
}

.nav-item svg {
  width: 1.2rem;
  margin-right: 5px;
}

.nav-item-children {
  z-index: 1;
  white-space: normal;
  word-wrap: break-word;
  padding: 10px;
  border: 1px solid var(--menu-border);
  background-color: var(--main-background);
  box-shadow: 0 0 7px 0 var(--shadow);
  position: absolute;
  display: none;
}
